module.exports = __webpack_public_path__ + "static/img/icon_play.9c1fd344.svg";